export default "__VITE_ASSET__a870f1c1__"